// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mail-solid';

export const Component = () => (
  <path d='M24.5 4.935v1.249l-11.25 6.57c-.234.14-.515.231-.75.231s-.515-.093-.75-.23L.5 6.183v-1.25c0-.416.14-.74.422-1.017.281-.278.61-.417 1.032-.417h21.092c.423 0 .75.139 1.032.417.281.277.422.601.422 1.018Zm-10.781 8.652a2.296 2.296 0 0 1-1.219.324 2.3 2.3 0 0 1-1.219-.324L.5 7.294v12.771c0 .417.14.74.422 1.018.281.278.61.417 1.032.417h21.092c.423 0 .75-.139 1.032-.417.281-.277.422-.601.422-1.018V7.295l-10.781 6.292Z' />
);

export const viewBox = '0 0 25 25';
